// iPadOS 13+ reports itself as "Macintosh", so touch support is the tiebreaker.
export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1)

// Every browser on iOS is WebKit underneath, but only Safari has "Přidat na plochu"
// in its share sheet, so the instructions differ.
export const isIOSSafari = () =>
  isIOS() && !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome/.test(navigator.userAgent)

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  // Legacy iOS flag — still the only reliable signal on older iOS versions.
  (window.navigator as any).standalone === true